<div
  class="preview-overlay"
  (click)="onOverlayClick($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'global.profile_preview_title' | translate"
>
  <div class="preview-content">
    <div class="preview-header">
      <h2 class="preview-title">{{ 'global.profile_preview_title' | translate }}</h2>
      <button type="button" class="close-button" (click)="close()" [attr.aria-label]="'global.close' | translate">
        &times;
      </button>
    </div>

    <div class="preview-body">
      <div class="preview-section">
        <h3 class="preview-section-title">{{ 'form.field.form_name' | translate }}</h3>
        <p class="preview-text">{{ previewData.name }}</p>
        <p class="preview-text-secondary">{{ previewData.email }}</p>
        <p class="preview-text-secondary">{{ previewData.city }}</p>
      </div>

      <div class="preview-section" *ngIf="previewData.knowledgeSkills.length > 0">
        <h3 class="preview-section-title">{{ 'global.knowledge_and_skills' | translate }}</h3>
        <div class="preview-skills-list">
          <div class="preview-skill-row" *ngFor="let skill of previewData.knowledgeSkills; let i = index">
            <span class="preview-skill-name">{{ skill.skill_name }}</span>
            <div class="preview-stars-readonly">
              <lib-stars-rate [index]="i" [starsRate]="skill.rating" [titlesDesc]="'skill_desc_level'"></lib-stars-rate>
            </div>
          </div>
        </div>
      </div>

      <div class="preview-section" *ngIf="previewData.softSkills.length > 0">
        <h3 class="preview-section-title">{{ 'global.soft_skills' | translate }}</h3>
        <div class="preview-skills-list">
          <div class="preview-skill-row" *ngFor="let skill of previewData.softSkills; let i = index">
            <span class="preview-skill-name">{{ skill.skill_name }}</span>
            <div class="preview-stars-readonly">
              <lib-stars-rate [index]="i" [starsRate]="skill.rating" [titlesDesc]="'skill_desc_level'"></lib-stars-rate>
            </div>
          </div>
        </div>
      </div>

      <div class="preview-section" *ngIf="previewData.languages.length > 0">
        <h3 class="preview-section-title">{{ 'global.languages' | translate }}</h3>
        <div class="preview-skills-list">
          <div class="preview-skill-row" *ngFor="let lang of previewData.languages; let i = index">
            <span class="preview-skill-name">{{ lang.skill_name }}</span>
            <div class="preview-stars-readonly" *ngIf="!lang.is_native">
              <lib-stars-rate [index]="i" [starsRate]="lang.rating" [titlesDesc]="'skill_desc_level'"></lib-stars-rate>
            </div>
            <span class="preview-native-label" *ngIf="lang.is_native">{{ 'global.native' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="preview-section" *ngIf="previewData.workHistory.length > 0">
        <h3 class="preview-section-title">{{ 'global.your_experience' | translate }}</h3>
        <div class="preview-detail-list">
          <div class="preview-detail-item" *ngFor="let job of previewData.workHistory">
            <div class="preview-detail-main">
              <div class="preview-detail-primary">{{ job.position_name }}</div>
              <div class="preview-detail-secondary" *ngIf="job.education_name">{{ job.education_name }}</div>
            </div>
            <div class="preview-detail-period" *ngIf="job.start_date || job.end_date">
              {{ job.start_date | monthYear }} - {{ job.end_date | monthYear }}
            </div>
          </div>
        </div>
      </div>

      <div class="preview-section" *ngIf="previewData.education.length > 0">
        <h3 class="preview-section-title">{{ 'global.your_education' | translate }}</h3>
        <div class="preview-detail-list">
          <div class="preview-detail-item" *ngFor="let edu of previewData.education">
            <div class="preview-detail-main">
              <div class="preview-detail-primary">{{ edu.school_name }}</div>
              <div class="preview-detail-secondary" *ngIf="edu.education_name">{{ edu.education_name }}</div>
              <div class="preview-detail-tertiary" *ngIf="edu.education_level">{{ edu.education_level }}</div>
            </div>
            <div class="preview-detail-period" *ngIf="edu.start_date || edu.end_date">
              {{ edu.start_date | monthYear }} - {{ edu.end_date | monthYear }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
